import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/projects/{id}', 'get'>;
type ResponseBody = OASOutput<O, '/api/projects/{id}', 'get'>;

type Params = {
  projectId: number;
};

type Result = {
  id: number;
  guid: string;
  name: string;
  watermark: string | null;
  logoUrl: string | null;
  courseFeedbackEmailAddress: string | null;
  isPubliclyAvailable: boolean;
};

export const getProjectFactory = (apiClient: ApiClient) => {
  const getProject = async (variables: Params) => {
    const requestParams = mapInputToRequestParams(variables);
    const response = await apiClient['/api/projects/{id}'].get(requestParams);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestParams = (input: Params): RequestParams => {
    return {
      params: {
        id: input.projectId,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      id: response.id,
      guid: response.guid,
      name: response.name,
      watermark: response.watermark ?? null,
      logoUrl: response.logoUrl ?? null,
      courseFeedbackEmailAddress: response.courseFeedbackEmailAddress ?? null,
      isPubliclyAvailable: response.isPubliclyAvailable,
    };
  };

  return getProject;
};
